import { IUser } from "models/IUser";

export enum UsersActionTypes {
  GET_USERS_LOADING = 'GET_USERS_LOADING',
  GET_USERS_SUCCESS = 'GET_USERS_SUCCESS',
  GET_USERS_FAIL = 'GET_USERS_FAIL',
}

interface GetUsersLoadingAction {
  type: UsersActionTypes.GET_USERS_LOADING;
}

interface GetUsersSuccessAction {
  type: UsersActionTypes.GET_USERS_SUCCESS;
  payload: {
    users: IUser[];
  }
}

interface GetUsersFailAction {
  type: UsersActionTypes.GET_USERS_FAIL;
  payload: {
    error: any;
  };
}

export type UsersActions = GetUsersLoadingAction | GetUsersSuccessAction | GetUsersFailAction;
